import React from 'react'
import styled from '@emotion/styled'
import { size } from '@floating-ui/react-dom'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { colors, font, radius, spacing } from '@mobi/component-library/Foundations'

export const NoSearchResults: React.FC = () => {
  return (
    <WrapperStyled data-header-size={size}>
      <div>
        <Icon name='LineSearchSm' size='6.4rem' color='currentColor' />
      </div>

      <div className='info-header__text'>
        <h2>No Results</h2>

        <div>
          <div>Sorry, we couldn’t find what</div>
          <div>you’re looking for.</div>
        </div>
      </div>
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.header({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: spacing.md,
  paddingTop: spacing.lg,

  '>div:first-of-type': {
    display: 'inline-flex',
    borderRadius: radius.full,
    justifyContent: 'center',
    alignItems: 'center',
    height: '10.4rem',
    width: '10.4rem',
    color: colors.studio[500],
    backgroundColor: colors.studio[100],
  },

  '.info-header__text': {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    fontFamily: font.family.primary,

    '> h2': {
      margin: 0,
      padding: 0,
      textShadow: 'none',
      fontSize: font.size.lg.fontSize,
      letterSpacing: font.size.lg.letterSpacing,
      lineHeight: font.size.lg.lineHeight,
      fontWeight: font.weight.semibold,
      color: colors.black,
      textTransform: 'unset',
      whiteSpace: 'pre-line',
    },

    '> div': {
      fontSize: font.size.lg.fontSize,
      letterSpacing: font.size.lg.letterSpacing,
      lineHeight: font.size.lg.lineHeight,
      fontWeight: font.weight.regular,
      color: colors.neutral[800],
    },
  },
})
